import types from './mainTypes'
import typesLogin from '../login/loginTypes'

let initialState = {
    isAppInitialized: false
}

const mainReducer = (state = initialState, action: any) => {
    switch (action.type) {

        // Выход из системы
        case typesLogin.LOGIN_SET_LOGOUT: {
            return {
                ...state = initialState
            }
        }

        // Инициализация приложения
        case types.MAIN_SET_APP_INITIALIZED: {
            return {
                ...state,
                isAppInitialized: action.isAppInitialized
            }
        }
    
        default: return state
    }
}

export default mainReducer